import React, { useEffect, useState } from "react";
import { Card, Row, Col } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import EnquiryModel from "../../components/enquirymodelcomponents/EnquiryModel";
import { CATEGORIES_API, SCRIPT_URL } from "../../config/config";
import axios from "axios";
import { Helmet } from 'react-helmet-async';
import Loader from "../../components/loaderspinnercomponents/Loader";
import CategoryHeader from "./CategoryHeader";
import BreadcrumbCateDetails from "../../components/breadcrumbcomponents/BreadcrumbCateDetails";
import FirstImage from "../../components/productcomponents/FirstImage";

const Categories = ({ categoryName: propCategoryName }) => {
  const categoryName = propCategoryName || useParams.categoryName;
  const navigate = useNavigate();
  const location = useLocation();
  const { id = 0, from = "category" } = location?.state || {};
  const [categoriesData, setCategoriesData] = useState(null); // Initialize as null
  const [responseData, setResponseData] = useState(null);
  const [loading, setLoading] = useState(true); // Start with true
  const [breadcrumbData, setBreadcrumbData] = useState([]);


  const fetchCategoriesData = async () => {
    try {
      const response = await axios.post(CATEGORIES_API, {
        slug: categoryName ? categoryName.replace(/~/g, '-') : ''
        // slug: slug
      });
      if (response.data?.STATUS === 200 && response.data?.DATA) {
        setCategoriesData([response.data.DATA]);
        setBreadcrumbData(response?.data?.DATA?.breadcrumb || []);
      }
      setResponseData(response.data);
    } catch (error) {
      console.error("Error fetching category data:", error);
    } finally {
      setLoading(false);
    }
  };

  const { pathname } = location;
  const pathSegments = pathname.split("/").filter(Boolean); // removes empty strings
  const dynamicCityFromURL = pathSegments.length >= 2 ? pathSegments[0] : "";
  const selectedLocation = dynamicCityFromURL.toLowerCase();

  // Update storage data when location changes
  const [storageData, setStorageData] = useState({
    locationDynamic: "LOCATION_DY",
    locationReplace: selectedLocation,
  });

  useEffect(() => {
    setStorageData({
      locationDynamic: "LOCATION_DY",
      locationReplace: selectedLocation,
    });
  }, [selectedLocation]);

  useEffect(() => {
    fetchCategoriesData();
  }, [categoryName, location?.state]);

  const [visibleItems, setVisibleItems] = useState(15);
  const [expanded, setExpanded] = useState(false);

  const handleToggleView = () => {
    if (expanded) {
      setVisibleItems(15);
    } else {
      setVisibleItems(
        categoriesData?.reduce(
          (acc, data) =>
            acc + (data.sub_subcategories?.length || data.child?.length || 0),
          0
        ) || 15
      );
    }
    setExpanded(!expanded);
  };

  const locationFinder = storageData?.locationReplace?.length > 0
    ? "/" + storageData.locationReplace
    : "";

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  const handleShow = (event) => {
    event.stopPropagation();
    setShow(true);
    const favicon = document.querySelector("link[rel~='icon']");
    if (favicon) {
      favicon.href = "%PUBLIC_URL%/favicon1.ico";
    }
  };

  // Only show loader when loading and no data yet
  if (loading && !categoriesData) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Loader />
      </div>
    );
  }

  // Don't render anything if no data yet (instead of showing empty structure)
  if (!categoriesData) {
    return null;
  }



  return (
    <>
      {categoriesData.map((data, i) => (
        <>
          <div className="d-sm-block d-md-none">
            <FirstImage image={data.category_mobile_banner} />
          </div>
          <div className="d-none d-md-block">
            <FirstImage image={data.category_desktop_banner} />
          </div>
        </>
      ))}
      <BreadcrumbCateDetails
        items={breadcrumbData}
        location={locationFinder}
      />
      <Helmet>
        <title>
          {categoriesData?.[0]?.meta_title
            ? categoriesData[0].meta_title.replace(
              "LOCATION_DY",
              selectedLocation || "Surat"
            )
            : `Best Saree, Kurtis, Lehenga, Blouse & So On Wholesaler In ${selectedLocation || "Surat"}`}
        </title>

        <link
          rel="canonical"
          href={`${window.location.hostname === "localhost" ? "http" : "https"
            }://${window.location.host}${window.location.pathname}`}
        />
        <link rel="publisher" href={`${SCRIPT_URL}`}></link>
        <meta
          name="description"
          property="og:description"
          content={
            categoriesData?.[0]?.meta_description
              ? categoriesData[0].meta_description.replace(/LOCATION_DY/g, selectedLocation || "Surat")
              : `Ladies clothes manufacturer in ${selectedLocation || "Surat"}. Shop wholesale wide range of saree, kurti, lehenga, blouse, leggings, dupatta, dress materials & more in ${selectedLocation || "Surat"}.`
          }
        />
        <meta
          name="keywords"
          content={
            categoriesData?.[0]?.meta_keyword
              ? categoriesData[0].meta_keyword.replace(/LOCATION_DY/g, selectedLocation || "Surat")
              : "Kesaria Textile Company | Fashion is King"
          }
        />

        <meta property="og:locale" content="en_US" />
        <meta
          property="og:site_name"
          content="Kesaria Textile Company | Fashion is King"
        />
        <meta
          property="og:title"
          content={`${categoriesData?.[0]?.meta_title
            ? categoriesData[0].meta_title.replace(/LOCATION_DY/g, selectedLocation || "Surat") + ` Manufacturers In ${selectedLocation || "Surat"}`
            : `Leading Saree Manufacturers In ${selectedLocation || "Surat"}`
            } | Kesaria Textile Company`}

        />
        <meta property="og:type" content="article" />
        <meta
          name="description"
          property="og:description"
          content={
            categoriesData?.[0]?.meta_description
              ? categoriesData[0].meta_description.replace(/LOCATION_DY/g, selectedLocation || "Surat")
              : "Kesaria Textile Company is leading saree manufacturer & wholesaler in Surat textile market. ★ Our customer support and factory rate make us a well-known women's clothing manufacturer."
          }

        />
        <meta
          property="og:url"
          content={`${window.location.hostname === "localhost" ? "http" : "https"
            }://${window.location.host}/${selectedLocation || "Surat"}/${categoriesData?.[0]?.meta_title
              ?.replace(/LOCATION_DY/g, selectedLocation)
              ?.replace(/\s+/g, "-")
              ?.toLowerCase()
            }`}
        />

        <meta
          property="article:published_time"
          content="2022-08-26T11:21:29+00:00"
        />
        <meta
          property="article:modified_time"
          content="2024-06-20T06:07:23+00:00"
        />
        <meta name="twitter:card" content="summary" />
        <meta
          name="twitter:title"
          content={`${categoriesData?.[0]?.meta_title
            ? categoriesData[0].meta_title
              .replace(/LOCATION_DY/g, selectedLocation || "Surat") + " Manufacturers In Surat"
            : "Leading Saree Manufacturers In Surat"
            } | Kesaria Textile Company`}

        />
        <meta
          name="twitter:description"
          content={
            categoriesData?.[0]?.meta_description
              ? categoriesData[0].meta_description.replace(/LOCATION_DY/g, selectedLocation || "Surat")
              : "Kesaria Textile Company is leading saree manufacturer & wholesaler in Surat textile market. ★ Our customer support and factory rate make us a well-known women's clothing manufacturer."
          }

        />
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "BreadcrumbList",
                "@id": "${SCRIPT_URL}/${selectedLocation}/${categoriesData?.meta_title
              ?.replace(/LOCATION_DY/g, selectedLocation)
              ?.replace(/\s+/g, "-")}"
,
                "itemListElement": [
                  {
                    "@type": "ListItem",
                    "@id": "${SCRIPT_URL}/${selectedLocation}/${categoriesData?.meta_title
              ?.replace(/LOCATION_DY/g, selectedLocation)
              ?.replace(/\s+/g, "-")}",
                    "position": 1,
                    "name": "Home",
                    "item": "${SCRIPT_URL}/${selectedLocation}/${categoriesData?.meta_title
              ?.replace(/LOCATION_DY/g, selectedLocation)
              ?.replace(/\s+/g, "-")}",
                    "nextItem": "${SCRIPT_URL}/${selectedLocation}/${categoriesData?.meta_title?.replace(/LOCATION_DY/g, selectedLocation)?.replace(
                /\s+/g, "-"
              )}"
                  },
                  {
                    "@type": "ListItem",
                    "@id": "${SCRIPT_URL}/${selectedLocation}/${categoriesData?.meta_title?.replace(/LOCATION_DY/g, selectedLocation)?.replace(
                /\s+/g, "-"
              )}",
                    "position": 2,
                    "name": "Categories Detail",
                    "previousItem": "${SCRIPT_URL}/${categoriesData?.meta_title?.replace(/LOCATION_DY/g, selectedLocation)?.replace(
                /\s+/g, "-"
              )}"
                  }
                ]
              },
              {
                "@type": "Organization",
                "@id": "${SCRIPT_URL}/${categoriesData?.meta_title?.replace(/LOCATION_DY/g, selectedLocation)?.replace(
                /\s+/g, "-"
              )}",
                "name": "Keasria Textile Company",
                "description": "Fashion is King",
                "url": "${SCRIPT_URL}/${categoriesData?.meta_title?.replace(/LOCATION_DY/g, selectedLocation)?.replace(
                /\s+/g, "-"
              )}",
                "logo": {
                  "@type": "ImageObject",
                  "url": "${SCRIPT_URL}/wp-content/uploads/2022/01/cropped-ktc-logo-1.webp",
                  "@id": "${SCRIPT_URL}/${selectedLocation}/${categoriesData?.meta_title?.replace(/LOCATION_DY/g, selectedLocation)?.replace(
                /\s+/g, "-"
              )}",
                  "width": 512,
                  "height": 512,
                  "caption": "cropped-ktc-logo-1.webp"
                },
                "image": {
                  "@id": "${SCRIPT_URL}/${selectedLocation}/${categoriesData?.meta_title?.replace(/LOCATION_DY/g, selectedLocation)?.replace(
                /\s+/g, "-"
              )}"
                }
              },
              {
                "@type": "WebPage",
                "@id": "${SCRIPT_URL}/${selectedLocation}/${categoriesData?.meta_title?.replace(/LOCATION_DY/g, selectedLocation)?.replace(
                /\s+/g, "-"
              )}",
                "url": "${SCRIPT_URL}/${selectedLocation}/${categoriesData?.meta_title?.replace(/LOCATION_DY/g, selectedLocation)?.replace(
                /\s+/g, "-"
              )}",
                "name": "Kesaria Textile categories-detail | Know About Textile Manufacturers & Wholesalers",
                "description": "Check here latest & updated textile manufacturers & wholesalers information. Our experts share some tips about buying & selling about our products.",
                "inLanguage": "en-US",
                "isPartOf": { "@id": "${SCRIPT_URL}/${categoriesData?.meta_title?.replace(/LOCATION_DY/g, selectedLocation)?.replace(
                /\s+/g, "-"
              )}" },
                "breadcrumb": { "@id": "${SCRIPT_URL}/${selectedLocation}/${categoriesData?.meta_title?.replace(/LOCATION_DY/g, selectedLocation)?.replace(
                /\s+/g, "-"
              )}" },
                "datePublished": "2022-03-31T16:02:12+05:30",
                "dateModified": "2024-05-22T13:59:10+05:30"
              },
              {
                "@type": "WebSite",
                "@id": "${SCRIPT_URL}/${categoriesData?.meta_title?.replace(/LOCATION_DY/g, selectedLocation)?.replace(
                /\s+/g, "-"
              )}",
                "url": "${SCRIPT_URL}/${categoriesData?.meta_title?.replace(/LOCATION_DY/g, selectedLocation)?.replace(
                /\s+/g, "-"
              )}",
                "name": "Kesaria Textile Company",
                "description": "Fashion is King",
                "inLanguage": "en-US",
                "publisher": { "@id": "${SCRIPT_URL}/${categoriesData?.meta_title?.replace(/LOCATION_DY/g, selectedLocation)?.replace(
                /\s+/g, "-"
              )}" }
              }
            ]
          }
          `}
        </script>
      </Helmet>

      <div className="background-image-container mt-0 mt-lg-5 mt-md-3">
        <div className="container mt-4">
          <div className="productdata">
            {categoriesData.map((data, i) => (
              <div key={i}>
                <CategoryHeader CategorydetailInfo={data} />
                <p className="pt-3 fs-2 fw-semibold">
                  {data.name},{" "}
                  {(data.sub_subcategories?.length || data.subcategories?.length || data.child?.length || 0)}{" "}
                  Categories
                </p>

                <Row xs={2} sm={2} md={3} lg={5} className="g-3 mt-2">
                  {(data.sub_subcategories || data.subcategories || data.child || [])
                    .slice(0, visibleItems)
                    .map((sub, index) => (
                      <Col key={index} className="mb-4">
                        <Card
                          className="product-card"
                          onClick={() => {
                            const location = storageData?.locationReplace;
                            const slug = sub?.slug?.toString().trim().replace(/~/g, "-").replace(/\s+/g, "-").toLowerCase();
                            const fullPath = location ? `/${location}/${slug}` : `/${slug}`;
                            navigate(fullPath, {
                              state: {
                                id: sub?.id,
                                name: sub?.name,
                              },
                            });
                          }}

                          style={{
                            background: sub.color_code,
                            cursor: "pointer",
                          }}
                        >
                          <div className="main">
                            <a
                              target="_blank"
                              href={sub?.catelog}
                              className="main"
                            >
                            </a>
                          </div>
                          <Card.Img
                            variant="top"
                            src={sub.image}
                            className="setimage"
                            loading="lazy"
                            alt={sub.name}
                          />
                          <button
                            className="btn btn-danger button-icon rounded-5"
                            onClick={handleShow}
                          >
                            GET QUOTE
                          </button>
                          <Card.Text className="text-center mt-2 mb-2 txtfamily fs-13 fw-medium text-light" style={{ letterSpacing: "1px" }}>
                            {sub.name}
                          </Card.Text>
                        </Card>
                      </Col>
                    ))}
                </Row>
              </div>
            ))}
            <div className="d-flex justify-content-center">
              <button
                className="them-color border-0 rounded-5 px-4 py-2 mt-3 mb-5 btn-red-to-black-color-move btnhoverblue"
                onClick={handleToggleView}
              >
                <span>{expanded ? "View Less" : "View More"}</span>
              </button>
            </div>
          </div>
        </div>
        <EnquiryModel show={show} handleClose={handleClose} />
      </div>
    </>
  );
};

export default Categories;